import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import {HistoryLogEntry} from "../types";

export class IntegrationsMarketplaceHistoryLogsBaseDataProvider extends BaseWebComponentDataProvider {
  public async clearLogs(integrationId: string): Promise<{success: boolean}> {
    throw Error('Needs to be implemented.');
  }

  public async getLogs(integrationId: string): Promise<{success: boolean, logs: HistoryLogEntry[]}> {
    throw Error('Needs to be implemented.');
  }
}
